<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.countingAdd" type="confirm" width="40%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="detail" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.owner')" prop="owner.id">
            <vxe-select v-model="order.owner.id" :options="owners" style="width: 100%" @change="onOwnerChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')" prop="item.no">
            <vxe-input v-model="detail.sku.item.no" :editable="false" style="width: 100%" @click="onSkuSelect"/>
            <sku-modal ref="skuModal" @change="onSkuChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="detail.sku.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.specification')">
            <vxe-input v-model="detail.sku.pack.specification" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.factor')">
            <vxe-input v-model="detail.sku.pack.factor" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.uom')">
            <vxe-input v-model="detail.sku.pack.uom" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.lotNo')">
            <vxe-input v-model="detail.sku.lot.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.productionDate')">
            <vxe-input v-model="detail.sku.lot.productionDate" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.validUntil')">
            <vxe-input v-model="detail.sku.lot.validUntil" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.locationNo')" prop="location.no">
            <vxe-input v-model="detail.location.no" :editable="false" style="width: 100%" @click="onLocationSelect"/>
            <location-modal ref="locationModal" @change="onLocationChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.containerNo')">
            <vxe-input v-model="detail.container.no" :editable="false" style="width: 100%" @click="onContainerSelect"/>
            <container-modal ref="containerModal" @change="onContainerChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.actualCountQuantity')" prop="quantity">
            <vxe-number-input v-model="detail.quantity" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.inventoryReason')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="reasons">
            <vxe-textarea v-model="detail.reasons" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findAll, post } from '@/api/Api'
import api from '@/api'
import { CountingDetail, CountingOrder } from '@/api/dto/order/CountingOrder'
import { OrderType } from '@/api/dto/common/OrderType'
import { Sku } from '@/api/dto/common/Sku'
import { Location } from '@/api/dto/common/Location'
import { Container } from '@/api/dto/common/Container'
import { BaseObject } from '@/api/dto/BaseObject'
import SkuModal from '@/views/modal/SkuModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import ContainerModal from '@/views/modal/ContainerModal.vue'
import { getOptions } from '@/utils/util'

export default {
  name: 'TemporaryCountingAdd',
  components: { ContainerModal, LocationModal, SkuModal },
  props: {
    orderType: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new CountingOrder(),
      detail: new CountingDetail(),
      owners: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        'owner.id': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'item.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        'location.no': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        quantity: [{ required: true, type: 'number', message: this.$t('message.canNotBeEmpty') }],
        reasons: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    })
  },
  methods: {
    onOwnerChange() {
      this.detail.sku = new Sku()
    },
    onSkuSelect() {
      if (this.order.owner.isNew()) {
        return this.$message.warning(this.$t('business.label.owner') + this.$t('message.canNotBeEmpty'))
      }
      this.$refs.skuModal.open({ 'owner.ids': [this.order.owner.id] })
    },
    onSkuChange(values) {
      this.detail.sku = new Sku(BaseObject.merge(values[0], 'sku'))
    },
    onLocationSelect() {
      this.$refs.locationModal.open({ locationType: 5 })
    },
    onLocationChange(values) {
      this.detail.location = new Location(values[0])
    },
    onContainerSelect() {
      this.$refs.containerModal.open({ available: true, physical: true })
    },
    onContainerChange(values) {
      this.detail.container = new Container(values[0])
    },
    open() {
      this.order.orderType = new OrderType(this.orderType)
      this.order.dataSource = 4
      this.visible = true
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      const detail = this.detail.toJSONObject()
      order.warehouse = this.warehouse
      order.details = [detail]
      post(api.countingSave, { type: 'inventoryCounter' }, order).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) this.save()
      })
    }
  }
}
</script>